(function () {
    'use strict';

    angular.module("imApp").factory("toolsMenuService", [function () {
        let service = {};

        return service;
    }]);
})();
